import React, { useState, useEffect } from "react";
import LoginImage from "../Login/LoginImage";
import {
  Navigate,
  Link,
  useParams,
  useNavigate,
  useLocation,
} from "react-router-dom";
import GoogleAuth from "../Login/LoginByGoogle";
import meetingPlusLogo from "../../assets/images/MinutesPlusVaultLogo1.svg";
import * as constantMessages from "../../constants/constatntMessages";


function AdminPanelLoginByOtp() {

  const location = useLocation();

  const { currentPath } = location.state || {};
    const [formData, setFormData] = useState({
      email: "",
    });
  
    const [isSetPassword, setIsSetPassword] = useState(false);
    const [errors, setErrors] = useState({});


  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Admin Login : MinutesVault";
  })


  const handleSetPassword = () => {
    navigate('/admin-set-password');
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = validateForm(formData);
    setErrors(newErrors);
    // dispatch(updateOtpProcessed(false));
    if (Object.keys(newErrors).length === 0) {
      // Form submission logic here
      // dispatch(sendOtp(formData.email, isSetPassword));
    }
  };

   const validateForm = (data) => {
      const errors = {};
      if (!data.email.trim()) {
        errors.email = constantMessages.emailRequired;
      } else if (!/\S+@\S+\.\S+/.test(data.email)) {
        errors.email = constantMessages.invalidEmail;
      }
      return errors;
    };

  return (
    <section className="sign-in login-page">

      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="loginform-container abstract-bg">
              <div className="logo-container">
                <Link to="/">
                  <img
                    className="login-logo"
                    // @ts-ignore
                    src={meetingPlusLogo}
                    alt="logo"
                  />
                </Link>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="text">
                  <h4>Welcome to MinutesVault</h4>
                  <p>
                    Please enter your email address to log in to your account.
                  </p>
                </div>

                <div className="form-group">
                  <div className="email-group mb-0">
                    <label className="mb-1">
                      Email <span className="imp-field">*</span>
                    </label>
                    <div className="inner-group">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        className="bi bi-envelope-at"
                        viewBox="0 0 16 16"
                      >
                        <path d="M2 2a2 2 0 0 0-2 2v8.01A2 2 0 0 0 2 14h5.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-.966-.741l5.64-3.471L8 9.583l7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2zm3.708 6.208L1 11.105V5.383zM1 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2z" />
                        <path d="M14.247 14.269c1.01 0 1.587-.857 1.587-2.025v-.21C15.834 10.43 14.64 9 12.52 9h-.035C10.42 9 9 10.36 9 12.432v.214C9 14.82 10.438 16 12.358 16h.044c.594 0 1.018-.074 1.237-.175v-.73c-.245.11-.673.18-1.18.18h-.044c-1.334 0-2.571-.788-2.571-2.655v-.157c0-1.657 1.058-2.724 2.64-2.724h.04c1.535 0 2.484 1.05 2.484 2.326v.118c0 .975-.324 1.39-.639 1.39-.232 0-.41-.148-.41-.42v-2.19h-.906v.569h-.03c-.084-.298-.368-.63-.954-.63-.778 0-1.259.555-1.259 1.4v.528c0 .892.49 1.434 1.26 1.434.471 0 .896-.227 1.014-.643h.043c.118.42.617.648 1.12.648m-2.453-1.588v-.227c0-.546.227-.791.573-.791.297 0 .572.192.572.708v.367c0 .573-.253.744-.564.744-.354 0-.581-.215-.581-.8Z" />
                      </svg>
                      <input
                        type="text"
                        placeholder="Type Your Email"
                        name="email"
                        // onChange={handleChange}
                        // onBlur={fieldValidationCheck}
                        //value={formData.email}
                        autocomplete="off"
                      />
                    </div>

                  </div>
                </div>

                <button
                  //disabled={authData.loading}
                  className="signin-btn1 mt-2"
                  type="submit"
                // onClick={() => setIsSetPassword(false)}
                >
                  Send OTP
                </button>



                <div className="or">or</div>

                <Link to="/admin-login-by-password" state={{ formData, currentPath }}>
                  <button
                    //disabled={authData.loading}
                    className="signin-btn2 background-wh"
                  // onClick={() => {
                  //   dispatch(updateIsSuccess(true));
                  // }}
                  >
                    Sign In With Password
                  </button>
                </Link>
                <div className="or">or</div>

                <GoogleAuth />

                {/* <div className="signUp text-center mb-2">
                <p>Don't have an account ? <Link to="/organization-registration" >Sign Up </Link></p>
              </div> */}

                <div className="set-pwd d-flex justify-content-between">
                  <button
                    type="submit"
                    className="signin-btn2 mb-0"
                    onClick={handleSetPassword}
                  //disabled={authData.loading}
                  >
                    Set Password
                  </button>
                  <a
                    className="signin-btn2 user-manual mb-0"
                    href="https://manual.minutesvault.com/user/"
                    target="_blank"
                  >
                    View User Manual
                  </a>
                </div>

              </form>

            </div>

          </div>
          <LoginImage />
        </div>
      </div >
    </section >
  )
}

export default AdminPanelLoginByOtp